import React, { useState } from 'react'
import { BaseUserProfile } from '@/api/types'
import { useTranslation } from 'react-i18next'
import HouseholdMemberItem from './HouseholdMemberItem'

import './HouseholdSelector.css'
import HousehouldMemberCreate from './HousehouldMemberCreate'

type Props = {
  householdMembers: BaseUserProfile[]
  isReadonly?: boolean
  onChange?: (householdMembers: BaseUserProfile[]) => void
}

export default function HouseholdSelector({
  householdMembers,
  isReadonly = false,
  onChange,
}: Props) {
  const { t } = useTranslation()
  const [error, setError] = useState(false)

  const handleAddMember = (newMember: BaseUserProfile) => {
    !isReadonly &&
      onChange?.([...householdMembers, { ...newMember, idUser: householdMembers.length + 2 }])
    setError(false)
  }

  const handleRemoveMember = (idUser: number) => {
    !isReadonly && onChange?.([...householdMembers.filter((item) => item.idUser !== idUser)])
  }

  return (
    <div style={{ width: '750px' }}>
      <div style={{ display: 'flex', gap: '10x' }}>
        <div>{t('profile.household')}</div>
        <div>
          {!isReadonly && (
            <HousehouldMemberCreate
              onAddProfile={handleAddMember}
              profilesCount={householdMembers.length}
            />
          )}
        </div>
      </div>
      <div>
        <div className="HouseholdSelector-grid HouseholdSelector-header">
          <span>#</span>
          <span>{t('profile.name')}</span>
          <span>{t('profile.age')}</span>
          <span>{t('profile.weight')}</span>
          <span>{t('profile.height')}</span>
          <span>{t('profile.gender')}</span>
          <span>{t('profile.activityLevel')}</span>
        </div>

        <div className="HouseholdSelector-list">
          {householdMembers.length > 0 ? (
            <>
              {householdMembers.map((item, index) => (
                <HouseholdMemberItem
                  key={index}
                  item={item}
                  isReadonly={isReadonly}
                  index={index}
                  onRemove={handleRemoveMember}
                />
              ))}
            </>
          ) : (
            <div className="HouseholdSelector-emptyText">{t('profile.noHouseholdMembers')}</div>
          )}
          {error && (
            <div className="HouseholdSelector-error">{t('ingredient.errorDeleteUnit')}</div>
          )}
        </div>
      </div>
    </div>
  )
}
